import React, { useCallback, useEffect, useState, forwardRef } from 'react';

import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/system';
import Sheet from '@mui/joy/Sheet';

/////////////////////Date Piker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';


///////////// Date Formate
import dateFormat, { masks } from "dateformat";
import dayjs from 'dayjs';

///////////////////mune DropDown
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import MoreVert from '@mui/icons-material/MoreVert';
import MenuButton from '@mui/joy/MenuButton';
import Dropdown from '@mui/joy/Dropdown';
import { Button } from '@mui/joy';
import Switch, { switchClasses } from '@mui/joy/Switch';

import TrashIcon from '../../assets/icons/trashIcon.svg'
import EditIcon from '../../assets/icons/edit.svg'



/////////////////////// Modal
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import DialogTitle from '@mui/joy/DialogTitle';
import Stack from '@mui/joy/Stack';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';




////////////////////// API
import { getCouponsDetails, deleteCoupon, updateCoupons } from '../../Api/Coupons';



const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },
    { label: "Schindler's List", year: 1993 },
    { label: 'Pulp Fiction', year: 1994 },
]


const schema = yup.object({
    code: yup.string().required("هذا الحقل مطلوب"),
    discount: yup.string().required("هذا الحقل مطلوب"),
    num_of_use: yup.string().required("هذا الحقل مطلوب"),
    expire_at: yup.string().required("هذا الحقل مطلوب"),

})

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function ListDescount({ coupons, getCoupons }) {
    const [checked, setChecked] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [couponId, setCouponId] = useState(null);
    const [couponEditId, setCouponEditId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null)
    
    const [openModal, setOpenModal] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            code: null,
            discount: null,
            percent: 0,
            num_of_use: null,
            expire_at: null
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const openConfirmDelete = (id) => {
        setCouponId(id)
        setOpenModal(true)
    }

    const removeCoupon = async () => {
        const res = await deleteCoupon(couponId)
        if (res) {
            setMessageAlert('تم حذف كود الخصم بنجاح')
            setOpenAlert(true)
            setOpenModal(false)
            getCoupons()
        }
    }

    const openEditCoupon = async (id) => {
        setCouponEditId(id)
        const res = await getCouponsDetails(id)
        if(res){
            let dateTest = new Date(res.expire_at)
            setSelectedDate(res.expire_at ? dayjs(res.expire_at) : null)
            setValue('code', res.code)
            setValue('discount', res.discount)
            setValue('num_of_use', res.num_of_use)
            if(res.percent == 0){
                setValue('percent', 0)
                setChecked(0)
            }else{
                setValue('percent', 1)
                setChecked(1)
            }
            setOpenEdit(true)
        }
    }

    const submitExpireDate = (data) => {
        // let formatDate = data.year() + '-' + (data.month() + 1) + '-' + data.day()
        let formatDate = dateFormat(data, 'd-m-yyyy')
        
        setValue('expire_at', formatDate)
        setSelectedDate(data)
        // console.log(formatDate)
    }



    const submitNewCode = async (data) => {
        if(data.percent) {
            data.percent = 1
        }else{
            data.percent = 0
        }
        const res = await updateCoupons(couponEditId, data);
        if(res){
            getCoupons();
            setMessageAlert('تم تعديل كود الخصم بنجاح')
            setOpenAlert(true)
            setOpenEdit(false)
            setValue('code', null)
            setValue('discount', null)
            setValue('expire_at', null)
            setValue('num_of_use', null)
            setValue('percent', 0)
        }
    }


    return (
        <>
            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            {/* Modal PopUp */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف كود الخصم ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف كود الخصم بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={() => removeCoupon()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModal(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>

            {/* Modal Create New */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', paddingTop: '0', direction: 'rtl' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{
                        Width: 500,
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                        position: 'relative',
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold' }}>إضافة كود جديد</DialogTitle>
                    {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                    <Box sx={{ width: '500px', paddingTop: '30px' }}>
                        <form
                            onSubmit={handleSubmit(submitNewCode)}
                        >
                            <Stack spacing={4}>
                                <FormControl>
                                    <FormLabel>اسم الكود</FormLabel>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        type='text'
                                        placeholder='ادخل اسم الكود هنا.....'
                                        {...register('code')}
                                    />
                                    {errors.code &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.code?.message}</Typography>
                                    }
                                </FormControl>

                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '20px' }}>
                                        <FormLabel>{checked ? 'نسبة الخصم' : 'قيمة للخصم'}</FormLabel>
                                        <Switch
                                            variant={checked ? 'solid' : 'outlined'}
                                            checked={checked}
                                            onChange={(event) => { setChecked(event.target.checked); setValue('percent', event.target.checked) }}
                                            sx={(theme) => ({
                                                display: 'inherit',
                                                '--Switch-trackWidth': '40px',
                                                '--Switch-trackHeight': '20px',
                                                '--Switch-thumbSize': '12px',
                                                '--Switch-thumbBackground': '#E8F5E9',
                                                '--Switch-trackBorderColor': '#3E64F4',
                                                '--Switch-trackBackground': theme.vars.palette.background.body,
                                                '&:hover': {
                                                    '--Switch-trackBorderColor': 'rgb(50, 49, 48)',
                                                    '--Switch-trackBackground': theme.vars.palette.background.body,
                                                },
                                                [`&.${switchClasses.checked}`]: {
                                                    '--Switch-trackBackground': '#3E64F4',
                                                    '&:hover': {
                                                        '--Switch-trackBackground': '#3E64F4',
                                                    },
                                                },
                                                [`&.${switchClasses.disabled}`]: {
                                                    '--Switch-thumbColor': '#C8C6C4',
                                                    '--Switch-trackBorderColor': '#C8C6C4',
                                                },
                                                [`&.${switchClasses.disabled}.${switchClasses.checked}`]: {
                                                    '--Switch-trackBackground': '#C8C6C4',
                                                    '--Switch-thumbColor': '#F3F2F1',
                                                },
                                                [theme.getColorSchemeSelector('dark')]: {
                                                    '--Switch-trackBorderColor': 'rgb(161, 159, 157)',
                                                    '--Switch-trackBackground': 'rgb(27, 26, 25)',
                                                    '--Switch-thumbBackground': 'rgb(161, 159, 157)',
                                                    '&:hover': {
                                                        '--Switch-trackBorderColor': '#fff',
                                                        '--Switch-thumbBackground': '#fff',
                                                    },
                                                    [`&.${switchClasses.checked}`]: {
                                                        '--Switch-trackBackground': 'rgb(40, 153, 245)',
                                                        '--Switch-thumbBackground': 'rgb(27, 26, 25)',
                                                        '&:hover': {
                                                            '--Switch-trackBackground': 'rgb(108, 184, 246)',
                                                        },
                                                    },
                                                },
                                            })}
                                        />
                                    </Box>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        placeholder={checked ? ' نسبة الخصم.....' : 'قيمة للخصم .....'}
                                        type='number'
                                        {...register('discount')}
                                    />
                                    {errors.discount &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.discount?.message}</Typography>
                                    }
                                </FormControl>

                                <FormControl>
                                    <FormLabel>عدد مرات استخدام الكود</FormLabel>
                                    <Input
                                        sx={{ height: '60px', borderRadius: '30px' }}
                                        type='number'
                                        placeholder='عدد استخدام الكود.....'
                                        {...register('num_of_use')}
                                    />
                                    {errors.num_of_use &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.num_of_use?.message}</Typography>
                                    }
                                </FormControl>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <FormControl>
                                        <FormLabel>تاريخ انتهاء الكود</FormLabel>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker 
                                                value={selectedDate} 
                                                onChange={submitExpireDate} 
                                                format='YYYY-MM-DD' 
                                                />
                                        </LocalizationProvider>
                                        {errors.expire_at &&
                                            <Typography
                                                color="danger"
                                                level="body-xs"
                                                variant="plain"
                                            >{errors.expire_at?.message}</Typography>
                                        }
                                    </FormControl>
                                </Box>

                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                    <Button type="submit" sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>تعديل الكود</Button>
                                    <Button type="button" onClick={() => setOpenEdit(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                                </Box>
                            </Stack>
                        </form>
                    </Box>
                </Sheet>
            </Modal>

            <Box
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                    gap: 2,
                    // justifyContent: 'stretch',
                    alignItems: 'stretch',
                    marginTop: '70px'
                }}
            >
                {coupons.map((coupon) => {
                    return (
                        <Card variant="soft" sx={{ backgroundColor: '#FFF', position: 'relative' }}>
                            <Box component="section" sx={{ width: '16px', height: '16px', position: 'absolute', top: '0', left: '0', zIndex: '999' }}>
                                <Dropdown>
                                    <MenuButton
                                        slots={{ root: IconButton }}
                                        slotProps={{ root: { variant: 'plan', color: 'plan' } }}
                                        sx={{ backgroundColor: '#3E64F4', borderRadius: '50%', color: '#FFF', scale: '0.7', position: 'absolute', left: '10px', top: '10px' }}
                                    >
                                        <MoreVert />
                                    </MenuButton>
                                    <Menu placement="bottom-end">
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => openConfirmDelete(coupon.id)}>
                                            <ListItemDecorator sx={{ color: 'inherit' }}>
                                                <img src={TrashIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            حذف الكود
                                        </MenuItem>
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => openEditCoupon(coupon.id)}>
                                            <ListItemDecorator>
                                                <img src={EditIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            تعديل الكود
                                        </MenuItem>
                                        {/* <MenuItem sx={{ color: '#434448' }}>
                                            نشر الكود
                                            <ListItemDecorator>
                                                <Switch
                                                    variant={checked ? 'solid' : 'outlined'}
                                                    checked={checked}
                                                    onChange={(event) => setChecked(event.target.checked)}
                                                    sx={(theme) => ({
                                                        display: 'inherit',
                                                        '--Switch-trackWidth': '40px',
                                                        '--Switch-trackHeight': '20px',
                                                        '--Switch-thumbSize': '12px',
                                                        '--Switch-thumbBackground': '#E8F5E9',
                                                        '--Switch-trackBorderColor': '#4CAF50',
                                                        '--Switch-trackBackground': theme.vars.palette.background.body,
                                                        '&:hover': {
                                                            '--Switch-trackBorderColor': 'rgb(50, 49, 48)',
                                                            '--Switch-trackBackground': theme.vars.palette.background.body,
                                                        },
                                                        [`&.${switchClasses.checked}`]: {
                                                            '--Switch-trackBackground': '#4CAF50',
                                                            '&:hover': {
                                                                '--Switch-trackBackground': '#106EBE',
                                                            },
                                                        },
                                                        [`&.${switchClasses.disabled}`]: {
                                                            '--Switch-thumbColor': '#C8C6C4',
                                                            '--Switch-trackBorderColor': '#C8C6C4',
                                                        },
                                                        [`&.${switchClasses.disabled}.${switchClasses.checked}`]: {
                                                            '--Switch-trackBackground': '#C8C6C4',
                                                            '--Switch-thumbColor': '#F3F2F1',
                                                        },
                                                        [theme.getColorSchemeSelector('dark')]: {
                                                            '--Switch-trackBorderColor': 'rgb(161, 159, 157)',
                                                            '--Switch-trackBackground': 'rgb(27, 26, 25)',
                                                            '--Switch-thumbBackground': 'rgb(161, 159, 157)',
                                                            '&:hover': {
                                                                '--Switch-trackBorderColor': '#fff',
                                                                '--Switch-thumbBackground': '#fff',
                                                            },
                                                            [`&.${switchClasses.checked}`]: {
                                                                '--Switch-trackBackground': 'rgb(40, 153, 245)',
                                                                '--Switch-thumbBackground': 'rgb(27, 26, 25)',
                                                                '&:hover': {
                                                                    '--Switch-trackBackground': 'rgb(108, 184, 246)',
                                                                },
                                                            },
                                                        },
                                                    })}
                                                />
                                                {' '}</ListItemDecorator>
                                        </MenuItem> */}

                                    </Menu>
                                </Dropdown>
                            </Box>
                            <CardContent>
                                {/* <Typography level="p" sx={{ fontSize: '14px', color: '#515151' }}>خصم رمضان</Typography> */}
                                <Typography level="h3" sx={{ fontSize: '14px', color: '#5B6668' }}>{coupon.code}</Typography>
                                <Typography level="h3" sx={{ fontSize: '24px', color: '#434448' }}>{coupon.percent == '1' ? ('% ' + coupon.discount) : (coupon.discount)}</Typography>
                            </CardContent>
                        </Card>
                    )
                })}
            </Box>
        </>

    );
}